import {
  WphkDesignComponent,
  type ClassToInterface,
} from '../../types/component';

export type KeyboardType = 'default' | 'confirm';

/** 键盘key的类型 */
export enum KeyboardKeyType {
  /** 键盘key的删除键 */
  Delete = 'delete',
  /** 键盘key的确认键 */
  Confirm = 'confirm',
  /** 键盘key的空白键 */
  Blank = 'blank',
}

/** 键盘的key键配置信息 */
export type KeyboardKeySetting = {
  /** 键盘key值 */
  key: string;
  /** 键盘key样式类名 */
  className?: string;
};

export class WphkDesignKeyboard extends WphkDesignComponent {
  /**
   * 键盘是否可见
   * @default false
   */
  visible?: boolean;

  /**
   * 键盘类型，可选值为 'default'（默认键盘）、'confirm'（带确认按钮的键盘）
   * @default 'default'
   */
  type?: KeyboardType;

  /**
   * 是否可输入小数点
   * @default false
   */
  decimal?: boolean;

  /**
   * 是否启用安全模式
   * @default false
   */
  safeMode?: boolean;

  /**
   * 右上角关闭按钮文案
   * @default ''
   */
  closeBtnText?: string;

  /**
   * 键盘内嵌的确认按钮文案
   * @default 'OK'
   */
  confirmBtnText?: string;
  /**
   * 是否允许用户点击键盘内嵌的确认按钮进行提交
   * @default false
   */
  confirmBtnEnable?: boolean;
}

export type KeyboardProps = ClassToInterface<WphkDesignKeyboard>;
